<template>
  <div>
    <div class="form-group">
      <div class="signature-pad type">
        <label for="fullName">
          {{ labels.fullName }}
        </label>
        <input
          id="fullName"
          v-model="fullName"
          name="fullName"
          type="text"
          ref="fullName"
        />
      </div>
    </div>
    <div class="form-group">
      <button type="submit" class="btn btn-primary btn-lg" :disabled="isEmpty">
        {{ labels.agree }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    labels: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      fullName: ''
    };
  },
  computed: {
    isEmpty() {
      return this.fullName.length === 0;
    }
  },
  mounted() {
    this.$refs.fullName.focus();
  }
};
</script>
